import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Nav, NavItem, NavLink, Col, Collapse } from 'reactstrap';
import { Switch, Route, Link } from 'react-router-dom';
import classnames from 'classnames';
import i18n from '../../../i18next';
import MaterialIcon from 'material-icons-react';

import GeneralScreen from "./restaurant/GeneralScreen";
import PosSettingsScreen from "./pos/PosSettingsScreen";
import TenderTypeMappingScreen from "./pos/TenderTypeMappingScreen";
import ChargeTypeMappingScreen from "./pos/ChargeTypeMappingScreen";
import OrderTypeMappingScreen from "./pos/OrderTypeMappingScreen";
import GeneralServicesScreen from './service/GeneralServicesScreen';
import OpeningHoursScreen from "./restaurant/OpeningHoursScreen";
import TaxesScreen from "./restaurant/TaxesScreen";
import DaysOffScreen from "./restaurant/DaysOffScreen";
import PaymentScreen from "./restaurant/PaymentScreen";
import DeliveryScreen from './service/DeliveryScreen';
import DeliveryZones from './service/DeliveryZonesScreen';
import CollectionScreen from './service/CollectionScreen';
import DineInScreen from './service/DineInScreen';
import CurbsideScreen from './service/CurbsideScreen';
import InStoreScreen from './service/InStoreScreen';

import {
    loadPosSettings,
    clearPosSettings,
    clearOrderTypeMappings,
    clearTenderTypeMappings,
    clearChargeTypeMappings,
    clearOpeningHours,
    clearTaxSettings,
    loadRestaurantSettings,
    clearRestaurantSettings,
    clearOrderTypes
} from "../../../actions/index";
import { isUserAllowedToSeePaymentType } from "../../../utils/CommonUtils";
import { MENUU_ADMIN, MENUU_MASTER_ADMIN } from '../../../utils/Constants';
// import Invoices from './restaurant/menuuBilling/Invoices';

class RestaurantSettingsContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activeTab: 'settings',
            collapseRestaurantSettings: true,
            collapsePosSettings: true,
            collapseServiceSettings: true
        };
    }

    componentWillMount() {
        const { id } = this.props.match.params;
        this.props.loadRestaurantSettings(id);
        this.props.loadPosSettings(id);
    }

    componentWillUnmount() {
        this.props.clearPosSettings();
        this.props.clearOrderTypeMappings();
        this.props.clearTenderTypeMappings();
        this.props.clearChargeTypeMappings();
        this.props.clearOpeningHours();
        this.props.clearTaxSettings();
        this.props.clearRestaurantSettings();
        this.props.clearOrderTypes();
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    toggleRestaurantSettings() {
        this.setState({
            collapseRestaurantSettings: !this.state.collapseRestaurantSettings
        });
    }

    togglePosSettings() {
        this.setState({
            collapsePosSettings: !this.state.collapsePosSettings
        });
    }

    toggleServiceSettings() {
        this.setState({
            collapseServiceSettings: !this.state.collapseServiceSettings
        });
    }

    renderSettings() {
        const { flexParent, sideMenuColumn, sideMenuContent } = styles;

        return (
            <Col style={flexParent}>
                <Col xs="auto" sm={2} style={sideMenuColumn} >
                    {this.renderSideMenu()}
                </Col>
                <Col xs="auto" sm={10} style={sideMenuContent}>
                    <Switch>
                        <Route path={`/restaurant/:id/settings/general`} component={GeneralScreen} />
                        <Route path={`/restaurant/:id/settings/pos`} component={PosSettingsScreen} />
                        <Route path={`/restaurant/:id/settings/ordertype`} component={OrderTypeMappingScreen} />
                        <Route path={`/restaurant/:id/settings/tendertype`} component={TenderTypeMappingScreen} />
                        <Route path={`/restaurant/:id/settings/chargetype`} component={ChargeTypeMappingScreen} />
                        <Route path={`/restaurant/:id/settings/openinghours`} component={OpeningHoursScreen} />
                        <Route path={`/restaurant/:id/settings/taxes`} component={TaxesScreen} />
                        <Route path={`/restaurant/:id/settings/generalservice`} component={GeneralServicesScreen} />
                        <Route path={`/restaurant/:id/settings/delivery`} component={DeliveryScreen} />
                        <Route path={`/restaurant/:id/settings/deliveryzones`} component={DeliveryZones} />
                        <Route path={`/restaurant/:id/settings/collection`} component={CollectionScreen} />
                        <Route path={`/restaurant/:id/settings/dinein`} component={DineInScreen} />
                        <Route path={`/restaurant/:id/settings/curbside`} component={CurbsideScreen} />
                        <Route path={`/restaurant/:id/settings/daysoff`} component={DaysOffScreen} />
                        <Route path={`/restaurant/:id/settings/payments`} component={PaymentScreen} />
                        <Route path={`/restaurant/:id/settings/instore`} component={InStoreScreen} />
                        {/* <Route path={`/restaurant/:id/settings/invoices`} component={Invoices} /> */}
                    </Switch>
                </Col>
            </Col>
        );
    }

    isTypeHidden(supportedType) {
        const { type } = this.props.posSettings;


        if (type !== undefined && type !== null && type !== '') {

            if (type.supportOrderTypes === false && supportedType == 'order') {
                return true;
            }

            if (type.supportTenderTypes === false && supportedType == 'tender') {
                return true;
            }

            if (type.supportChargeTypes == false && supportedType == 'charge') {
                return true;
            }
        } else {
            return false;
        }
    }


    renderSideMenu() {
        const { menuItem, menuItemCollapsed, lastMenuItem, subMenuItem, spaceBetween, tabIconStyle } = styles;
        const { id } = this.props.match.params;
        const { user, restaurant } = this.props;

        const locationSections = this.props.location.pathname.replace("/", "").replace(/\//g, " ").split(" ");

        const selectedSection = locationSections.slice(-1)[0];

        const restaurantSettings = this.state.collapseRestaurantSettings ? menuItemCollapsed : menuItem;
        const posSettings = this.state.collapsePosSettings ? menuItemCollapsed : menuItem;
        const serviceSettings = this.state.collapseServiceSettings ? menuItemCollapsed : lastMenuItem;

        let isChargeHidden, isOrderHidden, isTenderHidden;
        if (this.props.posSettings !== undefined && this.props.posSettings !== null && this.props.posSettings.type !== undefined && this.props.posSettings.type !== null) {
            isChargeHidden = this.props.posSettings.type.supportChargeTypes;
            isOrderHidden = this.props.posSettings.type.supportOrderTypes;
            isTenderHidden = this.props.posSettings.type.supportTenderTypes;
        } else {
            isChargeHidden = false;
            isOrderHidden = false;
            isTenderHidden = false;
        }

        let isUserAdmin = isUserAllowedToSeePaymentType(user);


        return (
            <div >
                <Nav vertical>
                    <NavItem>
                        <div style={restaurantSettings} onClick={this.toggleRestaurantSettings.bind(this)}>
                            <MaterialIcon icon="restaurant_menu" style={tabIconStyle} size={20} color="#000" />
                            <span style={spaceBetween}>{i18n.t('screens:restaurantsMainContainer.restaurantSettings')}</span>
                        </div>
                        <Collapse isOpen={this.state.collapseRestaurantSettings}>
                            <NavLink
                                id="generalSettings"
                                className={classnames({ active: selectedSection === 'general' })}
                                tag={Link} to={`/restaurant/${id}/settings/general`}
                                style={subMenuItem}>
                                {i18n.t('screens:restaurantsMainContainer.general')}
                            </NavLink>
                            <NavLink
                                id="openingHours"
                                className={classnames({ active: selectedSection == 'openinghours' })}
                                tag={Link} to={`/restaurant/${id}/settings/openinghours`}
                                style={subMenuItem} >
                                {i18n.t('screens:restaurantsMainContainer.openinghours')}
                            </NavLink>
                            <NavLink
                                id="daysOff"
                                className={classnames({ active: selectedSection === 'daysoff' })}
                                tag={Link} to={`/restaurant/${id}/settings/daysoff`}
                                style={subMenuItem}>
                                {i18n.t('screens:restaurantsMainContainer.daysoff')}
                            </NavLink>
                            {/* <NavLink
                                id="invoices"
                                className={classnames({ active: selectedSection === 'invoices' })}
                                tag={Link} to={`/restaurant/${id}/settings/invoices`}
                                style={subMenuItem}>
                                {i18n.t('screens:restaurantsMainContainer.invoices')}
                            </NavLink> */}
                            <NavLink
                                id="payments"
                                className={classnames({ active: selectedSection === 'payments' })}
                                hidden={user.role === MENUU_MASTER_ADMIN || user.role === MENUU_ADMIN ? false : true}
                                tag={Link} to={`/restaurant/${id}/settings/payments`}
                                style={subMenuItem} >
                                {i18n.t('screens:restaurantsMainContainer.payments')}
                            </NavLink>
                            <NavLink
                                id="taxes"
                                className={classnames({ active: selectedSection === 'taxes' })}
                                tag={Link} to={`/restaurant/${id}/settings/taxes`}
                                style={subMenuItem} >
                                {i18n.t('screens:restaurantsMainContainer.taxes')}
                            </NavLink>
                        </Collapse>
                    </NavItem>
                    <NavItem hidden={!isUserAdmin}>
                        <div style={posSettings} onClick={this.togglePosSettings.bind(this)}>
                            <MaterialIcon icon="desktop_mac" size={20} color="#000" />
                            <span style={spaceBetween}>{i18n.t('screens:restaurantsMainContainer.pos')}</span>
                        </div>
                        <Collapse isOpen={this.state.collapsePosSettings}>
                            <NavLink
                                id="posSettings"
                                className={classnames({ active: selectedSection === 'pos' })}
                                tag={Link}
                                to={`/restaurant/${id}/settings/pos`}
                                style={subMenuItem}>
                                {i18n.t('screens:restaurantsSettingsContainer.pos')}
                            </NavLink>
                            <NavLink
                                id="posOrderType"
                                className={classnames({ active: selectedSection === 'ordertype' })}
                                hidden={!isOrderHidden}
                                tag={Link} to={`/restaurant/${id}/settings/ordertype`}
                                style={subMenuItem}>
                                {i18n.t('screens:restaurantsMainContainer.ordertype')}
                            </NavLink>
                            <NavLink
                                id="posTenderType"
                                className={classnames({ active: selectedSection === 'tendertype' })}
                                hidden={!isTenderHidden}
                                tag={Link} to={`/restaurant/${id}/settings/tendertype`}
                                style={subMenuItem}>
                                {i18n.t('screens:restaurantsMainContainer.tendertype')}
                            </NavLink>
                            <NavLink
                                id="posChargeType"
                                className={classnames({ active: selectedSection === 'chargetype' })}
                                tag={Link} to={`/restaurant/${id}/settings/chargetype`}
                                hidden={!isChargeHidden}
                                style={subMenuItem}>
                                {i18n.t('screens:restaurantsMainContainer.chargetype')}
                            </NavLink>
                        </Collapse>
                    </NavItem>
                    <NavItem>
                        <div style={serviceSettings} onClick={this.toggleServiceSettings.bind(this)}>
                            <MaterialIcon icon="description" size={20} color="#000" />
                            <span style={spaceBetween}>{i18n.t('screens:restaurantsMainContainer.serviceSettings')}</span>
                        </div>
                        <Collapse isOpen={this.state.collapseServiceSettings} >
                            <NavLink
                                id="general"
                                className={classnames({ active: selectedSection === 'generalservice' })}
                                tag={Link} to={`/restaurant/${id}/settings/generalservice`}
                                style={subMenuItem}>
                                {i18n.t('screens:restaurantsMainContainer.general')}
                            </NavLink>
                            {this.renderDeliveryNavLink()}
                            {this.renderCollectionNavLink()}
                            {this.renderDineInNavLink()}
                            {this.renderCurbsideNavLink()}
                            {this.renderInStoreNavLink()}
                        </Collapse>
                    </NavItem>
                </Nav>
            </div>
        );
    }

    renderDeliveryNavLink() {
        const { serviceSettingsGeneral } = this.props;
        const { subMenuItem } = styles;
        const { id } = this.props.match.params;
        const locationSections = this.props.location.pathname.replace("/", "").replace(/\//g, " ").split(" ");

        const selectedSection = locationSections.slice(-1)[0];

        if (serviceSettingsGeneral !== undefined && serviceSettingsGeneral !== null
            && serviceSettingsGeneral.orderTypes !== undefined && serviceSettingsGeneral.orderTypes !== null) {

            return serviceSettingsGeneral.orderTypes.map((orderType, index) => {
                if (orderType.value == 'Delivery') {
                    return (
                        <div key={`${index}-delivery`}>
                            <NavLink
                                id="delivery"
                                className={classnames({ active: selectedSection === 'delivery' })}
                                tag={Link} to={`/restaurant/${id}/settings/delivery`}
                                style={subMenuItem}>
                                {i18n.t('screens:restaurantsMainContainer.delivery')}
                            </NavLink>
                            <NavLink
                                id="deliveryZones"
                                className={classnames({ active: selectedSection === 'deliveryzones' })}
                                tag={Link} to={`/restaurant/${id}/settings/deliveryzones`}
                                style={subMenuItem}>
                                {i18n.t('screens:restaurantsMainContainer.deliveryzones')}
                            </NavLink>
                        </div>
                    );
                }
            });
        }
    }

    renderCollectionNavLink() {
        const { serviceSettingsGeneral } = this.props;
        const { subMenuItem } = styles;
        const { id } = this.props.match.params;
        const locationSections = this.props.location.pathname.replace("/", "").replace(/\//g, " ").split(" ");

        const selectedSection = locationSections.slice(-1)[0];

        if (serviceSettingsGeneral !== undefined && serviceSettingsGeneral !== null
            && serviceSettingsGeneral.orderTypes !== undefined && serviceSettingsGeneral.orderTypes !== null) {

            return serviceSettingsGeneral.orderTypes.map((orderType, index) => {
                if (orderType.value == 'Collection') {
                    return (
                        <NavLink
                            key={`${index}-collection`}
                            id="collection"
                            className={classnames({ active: selectedSection === 'collection' })}
                            tag={Link} to={`/restaurant/${id}/settings/collection`}
                            style={subMenuItem}>
                            {i18n.t('screens:restaurantsMainContainer.collection')}
                        </NavLink>
                    );
                }
            })
        }
    }

    renderDineInNavLink() {
        const { serviceSettingsGeneral } = this.props;
        const { subMenuItem } = styles;
        const { id } = this.props.match.params;
        const locationSections = this.props.location.pathname.replace("/", "").replace(/\//g, " ").split(" ");

        const selectedSection = locationSections.slice(-1)[0];

        if (serviceSettingsGeneral !== undefined && serviceSettingsGeneral !== null
            && serviceSettingsGeneral.orderTypes !== undefined && serviceSettingsGeneral.orderTypes !== null) {

            return serviceSettingsGeneral.orderTypes.map((orderType, index) => {
                if (orderType.value == 'Dine In') {
                    return (
                        <NavLink
                            key={`${index}-dineIn`}
                            id="dineIn"
                            className={classnames({ active: selectedSection === 'dinein' })}
                            tag={Link} to={`/restaurant/${id}/settings/dinein`}
                            style={subMenuItem}>
                            {i18n.t('screens:restaurantsMainContainer.dinein')}
                        </NavLink>
                    );
                }
            })
        }
    }

    renderCurbsideNavLink() {
        const { serviceSettingsGeneral } = this.props;
        const { subMenuItem } = styles;
        const { id } = this.props.match.params;
        const locationSections = this.props.location.pathname.replace("/", "").replace(/\//g, " ").split(" ");

        const selectedSection = locationSections.slice(-1)[0];

        if (serviceSettingsGeneral !== undefined && serviceSettingsGeneral !== null
            && serviceSettingsGeneral.orderTypes !== undefined && serviceSettingsGeneral.orderTypes !== null) {

            return serviceSettingsGeneral.orderTypes.map((orderType, index) => {
                if (orderType.value == 'Curbside') {
                    return (
                        <NavLink
                            key={`${index}-curbside`}
                            id="curbside"
                            className={classnames({ active: selectedSection === 'curbside' })}
                            tag={Link} to={`/restaurant/${id}/settings/curbside`}
                            style={subMenuItem}>
                            {i18n.t('screens:restaurantsMainContainer.curbside')}
                        </NavLink>
                    );
                }
            });
        }
    }

    renderInStoreNavLink() {
        const { serviceSettingsGeneral } = this.props;
        const { subMenuItem } = styles;
        const { id } = this.props.match.params;
        const locationSections = this.props.location.pathname.replace("/", "").replace(/\//g, " ").split(" ");

        const selectedSection = locationSections.slice(-1)[0];

        if (serviceSettingsGeneral !== undefined && serviceSettingsGeneral !== null
            && serviceSettingsGeneral.orderTypes !== undefined && serviceSettingsGeneral.orderTypes !== null) {

            return serviceSettingsGeneral.orderTypes.map((orderType, index) => {
                if (orderType.value == 'In Store') {
                    return (
                        <NavLink
                            key={`${index}-instore`}
                            id='instore'
                            className={classnames({ active: selectedSection === 'instore' })}
                            tag={Link} to={`/restaurant/${id}/settings/instore`}
                            style={subMenuItem}>
                            {i18n.t('screens:restaurantsMainContainer.instore')}
                        </NavLink>
                    );
                }
            });
        }
    }

    render() {
        const { containerStyle } = styles;

        return (
            <div style={containerStyle}>
                {this.renderSettings()}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        restaurant: state.restaurant,
        restaurants: state.restaurants,
        posSettings: state.posSettings,
        orderTypes: state.orderTypes,
        serviceSettingsGeneral: state.serviceSettingsGeneral
    };
};

export default connect(
    mapStateToProps,
    {
        loadPosSettings,
        clearPosSettings,
        clearOrderTypeMappings,
        clearTenderTypeMappings,
        clearChargeTypeMappings,
        clearOpeningHours,
        clearTaxSettings,
        loadRestaurantSettings,
        clearRestaurantSettings,
        clearOrderTypes
    }
)(RestaurantSettingsContainer);

let styles = {
    containerStyle: {
        paddingLeft: 0,
        paddingRight: 0,
        height: '100%',
        display: 'flex'
    },
    sideMenuColumn: {
        backgroundColor: '#fafafa',
        padding: '0px 0px',
        width: 200,
        flex: '0 0 auto',
    },
    sideMenuContent: {
        paddingTop: 20,
        paddingLeft: 15,
        paddingRight: 0,
        flexDirection: 'column',
        flex: '1 1 auto',
        height: '100%',
    },
    menuItem: {
        color: '#000',
        fontSize: 14,
        paddingTop: 10,
        paddingRight: 15,
        paddingBottom: 10,
        paddingLeft: 15,
        borderTop: '1px solid #d9d9d9',
        borderBottom: '1px solid #f3f3f3',
        transition: 'border-bottom 0.75s',
        flexDirection: 'column',
        cursor: 'pointer'
    },
    menuItemCollapsed: {
        color: '#000',
        fontSize: 14,
        paddingTop: 10,
        paddingRight: 15,
        paddingBottom: 10,
        paddingLeft: 15,
        borderBottom: '1px solid #d9d9d9',
        borderTop: '1px solid #d9d9d9',
        flexDirection: 'column',
        cursor: 'pointer'
    },
    lastMenuItem: {
        color: '#000',
        fontSize: 14,
        paddingTop: 10,
        paddingRight: 15,
        paddingBottom: 10,
        paddingLeft: 15,
        borderTop: '1px solid #d9d9d9',
        borderBottom: '1px solid #d9d9d9',
        flexDirection: 'column',
        cursor: 'pointer'
    },
    subMenuItem: {
        display: 'flex',
        fontSize: 14,
        paddingLeft: 26
    },
    flexParent: {
        display: 'flex',
        paddingLeft: 0,
        alignItems: 'stretch',
        height: '100%',
        width: '96%'
    },
    spaceBetween: {
        paddingLeft: 4
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/RestaurantSettingsContainer.js